import { DWSTag } from "./tags";

export namespace Experience {
    export interface Translation {
        en?: string;
        it?: string;
        de?: string;
        es?: string;
        fr?: string;
    }

    export interface Photo {
        id: string;
        imageable_type: string;
        imageable_id: string;
        cover: boolean;
        created_at: string;
        updated_at: string;
        image_data: {
            id: string;
            storage: string;
            metadata: {
                filename: null | string;
                size: number;
                mime_type: string;
                width: number;
                height: number;
                public_id: string;
            };
        };
        title: string;
        main: boolean;
        urls: {
            forEach(arg0: (url: any) => void): unknown;
            original: string;
            s: string;
            m: string;
            v: string;
            l: string;
            xl: string;
            vv: string;
            p: string;
        };
    }

    export interface Product {
        id: string;
        name: string;
        description: string;
        wine_type: string;
        vine: string;
        alcoholic_degree: string;
        service_temperature: string;
        color: string;
        smell: string;
        taste: string;
        pairing: string;
        company_id: string;
        created_at: string;
        updated_at: string;
        description_translations: Translation;
        color_translations: Translation;
        smell_translations: Translation;
        taste_translations: Translation;
        pairing_translations: Translation;
        wine_type_translations: Translation;
        cover: Photo;
        photos: Photo[];
    }

    export interface Tag {
        id: string;
        name: string;
        color: string;
        created_at: string;
        updated_at: string;
        category_id: string;
        visible: boolean;
        hardcoded: boolean;
        code: string;
        name_translations: Translation;
        category_code: string;
    }

    export interface ExperiencePriceLabel {
        id: number;
        title_translations: Translation;
        price_cents: number;
        price_currency: string;
        position: number;
        experience_id: string;
        created_at: string;
        updated_at: string;
        quantity: number;
    }

    export interface Place {
        id: string;
        lat: string;
        lng: string;
        street: string;
        city: string;
        zipcode: string;
        province: string;
        state: string;
        region: string;
        placeable_type: string;
        placeable_id: string;
        created_at: string;
        updated_at: string;
        location: {
            lat: number;
            lon: number;
        };
    }

    export interface Cover {
        id: string;
        imageable_type: string;
        imageable_id: string;
        cover: boolean;
        created_at: string;
        updated_at: string;
        image_data: {
            id: string;
            storage: string;
            metadata: {
                filename: null | string;
                size: number;
                mime_type: string;
                width: number;
                height: number;
                public_id: string;
            };
        };
        title: string;
        main: boolean;
        urls: {
            original: string;
            s: string;
            m: string;
            v: string;
            l: string;
            xl: string;
            vv: string;
            p: string;
        };
    }

    // ============================================
    // VECCHIA INTERFACE - COMMENTATA PER ROLLBACK
    // ============================================
    /*
    export interface Experience {
company: any;
        id: string;
        title: string;
        summary: string;
        description: string;
        company_id: string;
        price_cents: number;
        price_currency: string;
        price_description: string;
        created_at: string;
        updated_at: string;
        duration_days: number;
        timetable: null | string;
        day_mon: boolean;
        day_tue: boolean;
        day_wed: boolean;
        day_thu: boolean;
        day_fri: boolean;
        day_sat: boolean;
        day_sun: boolean;
        title_translations: Translation;
        summary_translations: Translation;
        description_translations: Translation;
        event_date: null | string;
        price_description_translations: Translation;
        duration: string;
        price01_label: string;
        price01_label_translations: Translation;
        price02_label: string;
        price02_label_translations: Translation;
        price02_cents: number;
        price02_currency: string;
        deleted_at: null | string;
        show_website: boolean;
        show_widget: boolean;
        pay_at_the_winery: boolean;
        interval: number;
        checkout: null | string;
        meta_title_translations: Translation;
        meta_description_translations: Translation;
        notes: string;
        notice: number;
        instant_booking: boolean;
        antecedence: number;
        active: boolean;
        price02_active: boolean;
        accept_paypal_payments: boolean;
        accept_stripe_payments: boolean;
        state: string;
        min_parties_to_enable: number;
        max_parties: number;
        days_for_automatic_approve: number;
        enable_gifts: boolean;
        short_description_translations: {
            de: string;
            en: string;
            it: string;
        };
        priority: number;
        is_inquiry: boolean;
        is_gift_only: boolean;
        slot_automation_config: {};
        place: Place;
        photos: Photo[];
        products: Product[];
        cover: Cover;
        tags: Tag[];
        experience_price_extras: any[];
        experience_price_labels: ExperiencePriceLabel[];
    }
    */

    // ============================================
    // NUOVA INTERFACE - FORMATO NUOVO BACKEND
    // COMMENTATA - Non utilizzata, si usa direttamente Experience
    // ============================================
    /*
    export interface NewBackendExperience {
        id: string;
        wineryId: string;
        category: string;
        languagesIsoCode: string[];
        details: {
            experienceId: string;
            version: number;
            duration: string;
            interval: string;
            notice: string;
            antecedence: string;
            color: string;
            title: string;
            summary: string;
            description: string;
            metaTitle: string;
            metaDescription: string;
            updatedAt: string;
            showWebsite: boolean;
            showWidget: boolean;
            payAtTheWinery: boolean;
            instantBooking: boolean;
            acceptPaypalPayments: boolean;
            acceptStripePayments: boolean;
            minPartiesToEnable: number;
            maxParties: number;
            enableGifts: boolean;
            inquiry: boolean;
            giftOnly: boolean;
            daysForAutomaticApprove: number;
            priority: number;
            state: string;
            active: boolean;
            place: {
                lat: number;
                lng: number;
                street: string;
                zipcode: string;
                city: string;
                province: string;
                region: string;
                state: string;
            };
        };
        medias: Array<{
            id: number;
            experienceId: string;
            mediaName: string;
            mediaType: string;
            mime: string;
            mediaUrl: string;
            altName: string;
            active: boolean;
            updateTimestamp: string;
        }>;
        prices: Array<{
            price: number;
            priceSymbol: string;
            priceCurrency: string;
            priceDescription?: string;
        }>;
        metaDatas: Array<{
            id: number;
            experienceId: string;
            metadataName: string;
            metadataValue: string;
            active: boolean;
            updateTimestamp: string;
        }>;
        products: any[];
        rooms: Array<{
            id: number;
            experienceId: string;
            roomId: string;
        }>;
        employees: any[];
        slotAutomationTypes: any[];
        slotAutomationExecutions: any[];
    }
    */

    // ============================================
    // INTERFACE EXPERIENCE - ADATTATA AL NUOVO BACKEND
    // Formato diretto dal nuovo backend, senza trasformazioni
    // ============================================
    export interface Experience {
        id: string;
        wineryId: string;
        winery?: {
            name: string;
            city?: string;
            logo?: string;
        };
        category: string;
        languagesIsoCode: string[];
        details: {
            experienceId: string;
            version: number;
            duration: string;
            interval: string;
            notice: string;
            antecedence: string;
            color: string;
            title: string;
            summary: string;
            description: string;
            shortDescription?: string;
            metaTitle: string;
            metaDescription: string;
            note?: string;
            updatedAt: string;
            showWebsite: boolean;
            showWidget: boolean;
            payAtTheWinery: boolean;
            instantBooking: boolean;
            acceptPaypalPayments: boolean;
            acceptStripePayments: boolean;
            minPartiesToEnable: number;
            maxParties: number;
            enableGifts: boolean;
            inquiry: boolean;
            giftOnly: boolean;
            daysForAutomaticApprove: number;
            priority: number;
            state: string;
            active: boolean;
            place: {
                lat: number;
                lng: number;
                street: string;
                zipcode: string;
                city: string;
                province: string;
                region: string;
                state: string;
            };
        };
        medias: Array<{
            id: number;
            experienceId: string;
            mediaName: string;
            mediaType: string;
            mime: string;
            mediaUrl: string;
            altName: string;
            active: boolean;
            updateTimestamp: string;
        }>;
        prices: Array<{
            id: number;
            priceType: 'LABEL' | 'EXTRA';
            priceDescription?: string;
            position: number;
            price: number;
            priceCurrency: string;
            priceTitle?: string;
            extraMetadata?: any;
        }>;
        metaDatas: Array<{
            id: number;
            experienceId: string;
            metadataName: string;
            metadataValue: string;
            active: boolean;
            updateTimestamp: string;
        }>;
        products: any[];
        rooms: Array<{
            id: number;
            experienceId: string;
            roomId: string;
        }>;
        employees: any[];
        slotAutomationTypes: any[];
        slotAutomationExecutions: any[];
    }

    // ============================================
    // VECCHIA INTERFACE EXPERIENCE - COMMENTATA
    // ============================================
    /*
    export interface Experience {
        company: {
            wine_region_id?: string;
        };
        id: string;
        title: string;
        summary: string;
        description: string;
        company_id: string;
        price_cents: number;
        price_currency: string;
        price_description: string;
        created_at: string;
        updated_at: string;
        duration_days: number;
        timetable: null | string;
        day_mon: boolean;
        day_tue: boolean;
        day_wed: boolean;
        day_thu: boolean;
        day_fri: boolean;
        day_sat: boolean;
        day_sun: boolean;
        title_translations: Translation;
        summary_translations: Translation;
        description_translations: Translation;
        event_date: null | string;
        price_description_translations: Translation;
        duration: string;
        price01_label: string;
        price01_label_translations: Translation;
        price02_label: string;
        price02_label_translations: Translation;
        price02_cents: number;
        price02_currency: string;
        deleted_at: null | string;
        show_website: boolean;
        show_widget: boolean;
        pay_at_the_winery: boolean;
        interval: number;
        checkout: null | string;
        meta_title_translations: Translation;
        meta_description_translations: Translation;
        notes: string;
        notice: number;
        instant_booking: boolean;
        antecedence: number;
        active: boolean;
        price02_active: boolean;
        accept_paypal_payments: boolean;
        accept_stripe_payments: boolean;
        state: string;
        min_parties_to_enable: number;
        max_parties: number;
        days_for_automatic_approve: number;
        enable_gifts: boolean;
        short_description_translations: {
            de: string;
            en: string;
            it: string;
        };
        priority: number;
        is_inquiry: boolean;
        is_gift_only: boolean;
        slot_automation_config: {};
        place: Place;
        photos: Photo[];
        products: Product[];
        cover: Cover;
        tags: Tag[];
        experience_price_extras: any[];
        experience_price_labels: ExperiencePriceLabel[];
    }
    */
    export interface Language {
        id: string;
        title: Translation;
    }

    export interface FilterText{
        searchText?: string;
        lang: string | 'it';
    }

    export interface Filter {
        dateFrom?: string;
        dateTo?: string;
        adults?: number;
        priceMin?: number;
        priceMax?: number;
        radius?: string;
        geoShape?: any;
        latitude?: number;
        longitude?: number;
        wineryIds?: string[];
        experienceIds? : string[];
        experienceLanguages?: string[]; // comma separated iso lowercase ex: 'it,en' -> es traslate lang_it or lang_en MUST
        tags? : string[]; // comma separated tag id, contains all mood, exptype, visit_reason SHOULD
        services?: string[]; // array of service ids
        size: number;
        page: number;
        short?: any | false;
        lang: string | 'it';
    }

    export interface Short {
        id: string;
        wineryId: string;
        category: string;
        details: {
            duration: string;
            title: string;
            titles?: Array<{
                languageIsoCode: string;
                text: string;
            }>;
            shortDescription?: string;
            shortDescriptions?: Array<{
                languageIsoCode: string;
                text: string;
            }>;
            place: {
                lat: number;
                lng: number;
                street?: string;
                zipcode?: string;
                city?: string;
                province?: string;
                region?: string;
                state?: string;
            };
            showWebsite?: boolean;
            showWidget?: boolean;
            instantBooking?: boolean;
            enableGifts?: boolean;
            priority?: number;
            inquiry?: boolean;
            giftOnly?: boolean;
        };
        medias: Array<{
            mediaUrl: string;
            mediaType?: string;
        }>;
        prices: Array<{
            title: string;
            titles?: Array<{
                languageIsoCode: string;
                text: string;
            }>;
            description?: string;
            descriptions?: Array<{
                languageIsoCode: string;
                text: string;
            }>;
            priceCents: number;
            priceCurrency: string;
            position: number;
        }>;
        // Campi opzionali per compatibilità con vecchio codice
        cover?: string;
        img_url?: string;
        title?: string; // Deprecato, usare details.title
        short_description?: string; // Deprecato, usare details.shortDescription
        city?: string; // Deprecato, usare details.place.city
        province?: string; // Deprecato, usare details.place.province
        tags?: Tag[];
        dws_tags?: DWSTag[];
        company_id?: string; // Deprecato, usare wineryId
        price01_label?: string; // Deprecato, usare prices[0].title
        price_cents?: number; // Deprecato, usare prices[0].priceCents
        price02_label?: string; // Deprecato, usare prices[1].title
        price02_cents?: number; // Deprecato, usare prices[1].priceCents
        instant_booking?: boolean; // Deprecato, usare details.instantBooking
        location?: { coordinates: [number, number] }; // Deprecato, usare details.place
        company?: { id: string, name: string } // Deprecato, non più disponibile nel nuovo backend
    }

    export interface SearchWhereResult{
        id: string, 
        name: string, 
        location: {lat: number, lon:number}, 
        region?: any;
        province?: any;
        shape?: any;
        type?: 'regions' | 'provinces' | 'cities' | 'wine-regions';
        icon: string | 'assets/images/images/city-placeholder.jpg', 
        numExperiences: number | 0
    }

    export function extractExperienceLangs(experience: Experience): Language[] {
        if (!experience || !experience.languagesIsoCode) return [];
        // Usa direttamente languagesIsoCode dal nuovo backend
        return experience.languagesIsoCode.map((langCode: string) => {
            return { 
                id: langCode.toLowerCase(), 
                title: {} as Translation // Le traduzioni devono essere recuperate dal TagsService se necessario
            } as Language;
        });
    }

    export function extractExperienceLangsString(experience: Experience, lang: string): string {
        if (!experience) return '';
        let langs = extractExperienceLangs(experience);
        return langs.map(x => {
            if (lang === 'it') {
                return x.title.it;
            } else {
                return x.title.en;
            }
        }).join(', ');
    }

}


export type Experience = Experience.Experience;
export type Filter = Experience.Filter;
export type FilterText = Experience.FilterText;
export type ExperienceShort = Experience.Short;
export type SearchWhereResult = Experience.SearchWhereResult;
export type PlaceShort = Experience.Place;
